import type { ReactNode } from 'react';

import type { MenuItem } from '@/consts/navigation';
import type { SearchResult } from '@/features/header/hooks/useSearchResults';
import { normalizeString } from '@/utils/string';
import { t } from 'i18next';

export const flattenLeafItems = (items: MenuItem[] | undefined): MenuItem[] => {
  if (!items) return [];
  return items.flatMap((item) => {
    if (item.hidden) return [];
    const leaves: MenuItem[] = [];
    if (typeof item.to === 'string') {
      leaves.push(item);
    }
    if (item.children) {
      leaves.push(...flattenLeafItems(item.children));
    }
    return leaves;
  });
};

export const buildResults = (
  menuItemLabel: string,
  menuItemIcon: ReactNode,
  children: MenuItem[] | undefined
): SearchResult[] => {
  if (!children) return [];

  return children
    .filter((menuItem): menuItem is typeof menuItem & { to: string } => typeof menuItem.to === 'string')
    .map((menuItem) => ({
      category: menuItemLabel,
      label: t(menuItem.text),
      to: menuItem.to,
      icon: menuItemIcon
    }));
};

export const getFilteredChildren = (menuItem: MenuItem, regex: RegExp): MenuItem[] => {
  const allLeaves = flattenLeafItems(menuItem.children);
  return allLeaves.filter((item) => regex.test(normalizeString(t(item.text))));
};
